module.exports = __webpack_public_path__ + "static/media/cattle-drones-cattle.74b0541f.jpg";